// Serviço de polling automático do dispositivo que funciona em background
// mesmo quando o usuário não está na página de dispositivos

import axios from "axios";

class DispositivoPollingService {
  private intervalId: NodeJS.Timeout | null = null;
  private isRunning = false;

  start() {
    // Carrega configurações do localStorage
    const autoPolling =
      localStorage.getItem("dispositivo_auto_polling") === "true";
    const pollingInterval = parseInt(
      localStorage.getItem("dispositivo_polling_interval") || "30",
    );

    if (!autoPolling) {
      this.stop();
      return;
    }

    // Evita múltiplos intervals
    if (this.isRunning) {
      return;
    }

    this.isRunning = true;

    // Busca o CSRF token do meta tag
    const csrfToken =
      document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')
        ?.content || "";

    // Usa a rota da API
    const syncPath = "/api/v1/admin/dispositivos/sync";

    const headers = {
      "Content-Type": "application/json",
      "X-CSRF-Token": csrfToken,
      Accept: "application/json",
    };

    this.intervalId = setInterval(() => {
      // Executa sync em background
      axios
        .post(syncPath, {}, { headers })
        .then(() => {
          console.log(
            "[DispositivoPolling] Sincronização automática executada com sucesso",
          );
        })
        .catch((err) => {
          // Não loga erro se for 422 (aparelho não configurado)
          if (err?.response?.status !== 422) {
            console.error(
              "[DispositivoPolling] Erro na sincronização automática:",
              err,
            );
          }
        });
    }, pollingInterval * 1000);

    console.log(
      `[DispositivoPolling] Iniciado com intervalo de ${pollingInterval}s`,
    );
  }

  stop() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
      this.isRunning = false;
      console.log("[DispositivoPolling] Parado");
    }
  }

  restart() {
    this.stop();
    this.start();
  }
}

// Exporta uma instância singleton
export const dispositivoPollingService = new DispositivoPollingService();

// Auto-inicia quando o módulo é carregado
if (typeof window !== "undefined") {
  // Inicia o serviço quando a página carrega
  window.addEventListener("DOMContentLoaded", () => {
    dispositivoPollingService.start();
  });

  // Reinicia o serviço quando as configurações mudam
  window.addEventListener("storage", (e) => {
    if (
      e.key === "dispositivo_auto_polling" ||
      e.key === "dispositivo_polling_interval"
    ) {
      dispositivoPollingService.restart();
    }
  });
}
